import axios from "axios";
import {
  getToken,
  isTokenExpired,
  isPublicAuthEndpoint,
  forceLogout,
  shouldLogoutForError,
} from "../utils/authToken";

export const requestHandler = (request) => {
  const token = getToken();
  if (token && !isPublicAuthEndpoint(request.url)) {
    // If the token is already expired, log out and don't even send the request.
    if (isTokenExpired(token)) {
      forceLogout("expired");
      return Promise.reject(new axios.Cancel("Session expired"));
    }
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};

export const successHandler = (response) => {
  return {
    ...response,
    data: response.data,
  };
};

export const errorHandler = (error) => {
  // On any auth failure (expired/invalid token) log the user out globally.
  if (shouldLogoutForError(error)) {
    forceLogout("expired");
  }
  return Promise.reject(error);
};
